/**
 * DevExtreme (client_exporter/excel_languages.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
var LANGUAGE_CODES = {
    ar: 1,
    bg: 2,
    ca: 3,
    "zh-Hans": 4,
    cs: 5,
    da: 6,
    de: 7,
    el: 8,
    en: 9,
    es: 10,
    fi: 11,
    fr: 12,
    he: 13,
    hu: 14,
    is: 15,
    it: 16,
    ja: 17,
    ko: 18,
    nl: 19,
    no: 20,
    pl: 21,
    pt: 22,
    rm: 23,
    ro: 24,
    ru: 25,
    hr: 26,
    sk: 27,
    sq: 28,
    sv: 29,
    th: 30,
    tr: 31,
    ur: 32,
    id: 33,
    uk: 34,
    be: 35,
    sl: 36,
    et: 37,
    lv: 38,
    lt: 39,
    tg: 40,
    fa: 41,
    vi: 42,
    hy: 43,
    az: 44,
    eu: 45,
    hsb: 46,
    mk: 47,
    tn: 50,
    xh: 52,
    zu: 53,
    af: 54,
    ka: 55,
    fo: 56,
    hi: 57,
    mt: 58,
    se: 59,
    ga: 60,
    ms: 62,
    kk: 63,
    ky: 64,
    sw: 65,
    tk: 66,
    uz: 67,
    tt: 68,
    bn: 69,
    pa: 70,
    gu: 71,
    or: 72,
    ta: 73,
    te: 74,
    kn: 75,
    ml: 76,
    as: 77,
    mr: 78,
    sa: 79,
    mn: 80,
    bo: 81,
    cy: 82,
    km: 83,
    lo: 84,
    gl: 86,
    kok: 87,
    syr: 90,
    si: 91,
    iu: 93,
    am: 94,
    tzm: 95,
    ne: 97,
    fy: 98,
    ps: 99,
    fil: 100,
    dv: 101,
    ha: 104,
    yo: 106,
    quz: 107,
    nso: 108,
    ba: 109,
    lb: 110,
    kl: 111,
    ig: 112,
    ii: 120,
    arn: 122,
    moh: 124,
    br: 126,
    ug: 128,
    mi: 129,
    oc: 130,
    co: 131,
    gsw: 132,
    sah: 133,
    qut: 134,
    rw: 135,
    wo: 136,
    prs: 140,
    gd: 145,
    "ar-SA": 1025,
    "bg-BG": 1026,
    "ca-ES": 1027,
    "zh-TW": 1028,
    "cs-CZ": 1029,
    "da-DK": 1030,
    "de-DE": 1031,
    "el-GR": 1032,
    "en-US": 1033,
    "fi-FI": 1035,
    "fr-FR": 1036,
    "he-IL": 1037,
    "hu-HU": 1038,
    "is-IS": 1039,
    "it-IT": 1040,
    "ja-JP": 1041,
    "ko-KR": 1042,
    "nl-NL": 1043,
    "nb-NO": 1044,
    "pl-PL": 1045,
    "pt-BR": 1046,
    "rm-CH": 1047,
    "ro-RO": 1048,
    "ru-RU": 1049,
    "hr-HR": 1050,
    "sk-SK": 1051,
    "sq-AL": 1052,
    "sv-SE": 1053,
    "th-TH": 1054,
    "tr-TR": 1055,
    "ur-PK": 1056,
    "id-ID": 1057,
    "uk-UA": 1058,
    "be-BY": 1059,
    "sl-SI": 1060,
    "et-EE": 1061,
    "lv-LV": 1062,
    "lt-LT": 1063,
    "tg-Cyrl-TJ": 1064,
    "fa-IR": 1065,
    "vi-VN": 1066,
    "hy-AM": 1067,
    "az-Latn-AZ": 1068,
    "eu-ES": 1069,
    "hsb-DE": 1070,
    "mk-MK": 1071,
    "tn-ZA": 1074,
    "xh-ZA": 1076,
    "zu-ZA": 1077,
    "af-ZA": 1078,
    "ka-GE": 1079,
    "fo-FO": 1080,
    "hi-IN": 1081,
    "mt-MT": 1082,
    "se-NO": 1083,
    "ms-MY": 1086,
    "kk-KZ": 1087,
    "ky-KG": 1088,
    "sw-KE": 1089,
    "tk-TM": 1090,
    "uz-Latn-UZ": 1091,
    "tt-RU": 1092,
    "bn-IN": 1093,
    "pa-IN": 1094,
    "gu-IN": 1095,
    "or-IN": 1096,
    "ta-IN": 1097,
    "te-IN": 1098,
    "kn-IN": 1099,
    "ml-IN": 1100,
    "as-IN": 1101,
    "mr-IN": 1102,
    "sa-IN": 1103,
    "mn-MN": 1104,
    "bo-CN": 1105,
    "cy-GB": 1106,
    "km-KH": 1107,
    "lo-LA": 1108,
    "gl-ES": 1110,
    "kok-IN": 1111,
    "syr-SY": 1114,
    "si-LK": 1115,
    "iu-Cans-CA": 1117,
    "am-ET": 1118,
    "ne-NP": 1121,
    "fy-NL": 1122,
    "ps-AF": 1123,
    "fil-PH": 1124,
    "dv-MV": 1125,
    "ha-Latn-NG": 1128,
    "yo-NG": 1130,
    "quz-BO": 1131,
    "nso-ZA": 1132,
    "ba-RU": 1133,
    "lb-LU": 1134,
    "kl-GL": 1135,
    "ig-NG": 1136,
    "ii-CN": 1144,
    "arn-CL": 1146,
    "moh-CA": 1148,
    "br-FR": 1150,
    "ug-CN": 1152,
    "mi-NZ": 1153,
    "oc-FR": 1154,
    "co-FR": 1155,
    "gsw-FR": 1156,
    "sah-RU": 1157,
    "qut-GT": 1158,
    "rw-RW": 1159,
    "wo-SN": 1160,
    "prs-AF": 1164,
    "gd-GB": 1169,
    "ar-IQ": 2049,
    "zh-CN": 2052,
    "de-CH": 2055,
    "en-GB": 2057,
    "es-MX": 2058,
    "fr-BE": 2060,
    "it-CH": 2064,
    "nl-BE": 2067,
    "nn-NO": 2068,
    "pt-PT": 2070,
    "sr-Latn-CS": 2074,
    "sv-FI": 2077,
    "az-Cyrl-AZ": 2092,
    "dsb-DE": 2094,
    "se-SE": 2107,
    "ga-IE": 2108,
    "ms-BN": 2110,
    "uz-Cyrl-UZ": 2115,
    "bn-BD": 2117,
    "mn-Mong-CN": 2128,
    "iu-Latn-CA": 2141,
    "tzm-Latn-DZ": 2143,
    "quz-EC": 2155,
    "ar-EG": 3073,
    "zh-HK": 3076,
    "de-AT": 3079,
    "en-AU": 3081,
    "es-ES": 3082,
    "fr-CA": 3084,
    "sr-Cyrl-CS": 3098,
    "se-FI": 3131,
    "quz-PE": 3179,
    "ar-LY": 4097,
    "zh-SG": 4100,
    "de-LU": 4103,
    "en-CA": 4105,
    "es-GT": 4106,
    "fr-CH": 4108,
    "hr-BA": 4122,
    "smj-NO": 4155,
    "ar-DZ": 5121,
    "zh-MO": 5124,
    "de-LI": 5127,
    "en-NZ": 5129,
    "es-CR": 5130,
    "fr-LU": 5132,
    "bs-Latn-BA": 5146,
    "smj-SE": 5179,
    "ar-MA": 6145,
    "en-IE": 6153,
    "es-PA": 6154,
    "fr-MC": 6156,
    "sr-Latn-BA": 6170,
    "sma-NO": 6203,
    "ar-TN": 7169,
    "en-ZA": 7177,
    "es-DO": 7178,
    "sr-Cyrl-BA": 7194,
    "sma-SE": 7227,
    "ar-OM": 8193,
    "en-JM": 8201,
    "es-VE": 8202,
    "bs-Cyrl-BA": 8218,
    "sms-FI": 8251,
    "ar-YE": 9217,
    "en-029": 9225,
    "es-CO": 9226,
    "sr-Latn-RS": 9242,
    "smn-FI": 9275,
    "ar-SY": 10241,
    "en-BZ": 10249,
    "es-PE": 10250,
    "sr-Cyrl-RS": 10266,
    "ar-JO": 11265,
    "en-TT": 11273,
    "es-AR": 11274,
    "sr-Latn-ME": 11290,
    "ar-LB": 12289,
    "en-ZW": 12297,
    "es-EC": 12298,
    "sr-Cyrl-ME": 12314,
    "ar-KW": 13313,
    "en-PH": 13321,
    "es-CL": 13322,
    "ar-AE": 14337,
    "es-UY": 14346,
    "ar-BH": 15361,
    "es-PY": 15370,
    "ar-QA": 16385,
    "en-IN": 16393,
    "es-BO": 16394,
    "en-MY": 17417,
    "es-SV": 17418,
    "en-SG": 18441,
    "es-HN": 18442,
    "es-NI": 19466,
    "es-PR": 20490,
    "es-US": 21514,
    "bs-Cyrl": 25626,
    "bs-Latn": 26650,
    "sr-Cyrl": 27674,
    "sr-Latn": 28698,
    smn: 28731,
    "az-Cyrl": 29740,
    sms: 29755,
    zh: 30724,
    nn: 30740,
    bs: 30746,
    "az-Latn": 30764,
    sma: 30779,
    "uz-Cyrl": 30787,
    "mn-Cyrl": 30800,
    "iu-Cans": 30813,
    "zh-Hant": 31748,
    nb: 31764,
    sr: 31770,
    "tg-Cyrl": 31784,
    dsb: 31790,
    smj: 31803,
    "uz-Latn": 31811,
    "mn-Mong": 31824,
    "iu-Latn": 31837,
    "tzm-Latn": 31839,
    "ha-Latn": 31848
};
exports.getLanguageID = function(locale) {
    return LANGUAGE_CODES[locale]
};



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/devextreme/client_exporter/excel_languages.js
// module id = ../../../../devextreme/client_exporter/excel_languages.js
// module chunks = 3